<template>
  <div class="fl-sym-mt-20">
    <div class="fl-sym-px-4 fl-sym-mt-1">
      <div class="fl-sym-text-primary fl-sym-text-xxs regular fl-sym-text-dark-blue fl-sym-letter-space-08">
        CREATE ACCOUNT
      </div>
      <div
          class="fl-sym-text-black fl-sym-text-3xl fl-sym-leading-tight fl-sym-font-bold fl-sym-mb-2 fl-sym-letter-space-minus-02 "
      >
        We just need an email and password to save your pet’s information.
      </div>
      <div class="fl-sym-text-intermediate fl-sym-letter-space-056 fl-sym-text-lg fl-sym-mt-3">
        Enter your login details.
      </div>
      <form class="fl-sym-mt-8 xnpms:fl-sym-mt-16" @submit.prevent="submit">
        <div v-if="user">
          <div class="fl-sym-border fl-sym-border-graduate fl-sym-rounded fl-sym-px-3 fl-sym-mb-2 fl-sym-py-1">
          <label for="email">Email</label>
          <input
              id="email"
              placeholder="Email"
              v-model="user.email"
              name="email_input"
              required
              class="fl-sym-w-full fl-sym-mb-1 fl-sym-text-lg focus:fl-sym-outline-none focus:fl-sym-border-secondary fl-sym-placeholder-graduate"
          />
          </div>
          <div v-if="errors">
          <div class="fl-sym-text-red-600 fl-sym-mt-1 fl-sym-ml-3 fl-sym-mt-1" v-if="errors.email">
            <font-awesome-icon icon="exclamation-circle"></font-awesome-icon>
            &nbsp;
            {{ errors.email[0] }}
          </div>
            </div>
        </div>

                <div v-if="user" >
          <div class="fl-sym-border fl-sym-border-graduate fl-sym-rounded fl-sym-px-3 fl-sym-mb-2 fl-sym-mt-8 fl-sym-py-1">
          <label for="confirm-email">Confirm Email</label>
          <input
              id="confirm-email"
              placeholder="Confirm Email"
              name="confirm_email_input"
              required
              class="fl-sym-w-full fl-sym-mb-1 fl-sym-text-lg focus:fl-sym-outline-none focus:fl-sym-border-secondary fl-sym-placeholder-graduate"
          />
          </div>
                  <div v-if="errors">
          <div class="fl-sym-text-red-600 fl-sym-mt-1 fl-sym-ml-3 fl-sym-mt-1" v-if="errors.email">
            <font-awesome-icon icon="exclamation-circle"></font-awesome-icon>
            &nbsp;
            {{ errors.email }}
          </div>
                  </div>
        </div>

        <div v-if="user">
          <div class="fl-sym-border fl-sym-border-graduate fl-sym-rounded fl-sym-px-3 fl-sym-mb-2 fl-sym-mt-8 fl-sym-py-1 password-box">
          <label for="password">Password</label>
            <button class="show-password fl-sym-text-xs fl-sym-text-dark-blue fl-sym-font-semibold" @click="showPassword">{{ btnText }}</button>
          <input
              placeholder="Password"
              v-model="user.password1"
              name="password_input"
              id="password1"
              required
              :type="type"
              class="fl-sym-mb-1 field__input fl-sym-text-lg focus:fl-sym-outline-none focus:fl-sym-border-secondary fl-sym-placeholder-graduate"
          />
          </div>

          <div v-if="errors">

            <div class="fl-sym-text-red-600 fl-sym-mt-1 fl-sym-ml-3 fl-sym-mt-1" v-if="errors.password1">
              <font-awesome-icon icon="exclamation-circle"></font-awesome-icon>
              &nbsp;
              {{ errors.password1[0] }}
            </div>
          </div>
          <div class="fl-sym-border fl-sym-border-graduate fl-sym-rounded fl-sym-px-3 fl-sym-mb-2 fl-sym-py-1 fl-sym-mt-8 password-box">
          <label for="password2">Confirm Password</label>
            <button class="show-password fl-sym-text-xs fl-sym-text-dark-blue fl-sym-font-semibold" @click="showConfirmPassword">{{ btnText2 }}</button>
          <input
              placeholder="Confirm password"
              :type="type2"
              id="password2"
              required
              name="password_confirmation"
              v-model="user.password2"
              class="fl-sym-mb-1 field__input fl-sym-text-lg focus:fl-sym-outline-none focus:fl-sym-border-secondary fl-sym-placeholder-graduate"
          />
            </div>

          <div v-if="errors">
            <div class="fl-sym-text-red-600 fl-sym-mt-1 fl-sym-ml-3 fl-sym-mt-1" v-if="errors.password2">
              <font-awesome-icon icon="exclamation-circle"></font-awesome-icon>
              &nbsp;
              {{ errors.password2[0] }}
            </div>
            <div class="fl-sym-text-red-600 fl-sym-mt-1 fl-sym-ml-3 fl-sym-mt-1" v-if="errors.non_field_errors">
              <font-awesome-icon icon="exclamation-circle"></font-awesome-icon>&nbsp;
              {{ errors.non_field_errors[0] }}
            </div>
          </div>
        </div>

        <div class="fl-sym-mt-10 fl-sym-mb-2">
          <button
              type="submit"
              class="login-btn fl-sym-text-white hover:fl-sym-text-opacity-75 fl-sym-bg-primary fl-sym-rounded-full fl-sym-text-white fl-sym-p-3 fl-sym-w-full fl-sym-text-sm"
          >
            Log in
          </button>
        </div>
        <div class="fl-sym-flex fl-sym-justify-center fl-sym-text-sm fl-sym-mt-4">
        <div class="fl-sym-text-primary fl-sym-font-semibold hover:fl-sym-text-opacity-75" style="cursor: pointer" @click="back">
          Back
        </div>
      </div>
      </form>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  data() {
    return {
      type: 'password',
      btnText: 'SHOW',
      type2: 'password',
      btnText2: 'SHOW',
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      errors: state => state.auth.errors
    }),
  },
  methods: {
    submit() {
      this.$store.dispatch('auth/register_step_2', this.user)
    },
    back() {
      this.$router.go("-1");
    },
    showPassword() {
			if(this.type === 'password') {
				this.type = 'text'
				this.btnText = 'HIDE'
			} else {
				this.type = 'password'
				this.btnText = 'SHOW'
			}
		},
    showConfirmPassword() {
			if(this.type2 === 'password') {
				this.type2 = 'text'
				this.btnText2 = 'HIDE'
			} else {
				this.type2 = 'password'
				this.btnText2 = 'SHOW'
			}
		}
  },
};
</script>
<style>
.error {
  top: 460px;
  left: 20px;
  width: 366px;
  height: 16px;
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  letter-spacing: 0px;
  opacity: 1;
  font: "SFProDisplay-Regular";
  font-size: 16px;
  color: #ff3a19;
}

.border-red {
  border-color: #ff3a19;
}


.login-btn {
  background: transparent linear-gradient(262deg, #19e0ff 0%, var(--progress-bar-filler) 100%) 0% 0% no-repeat padding-box;
  background: transparent linear-gradient(262deg, #19e0ff 0%, #00c5e3 100%) 0% 0% no-repeat padding-box;
  opacity: 1;
}

.email-password {
  background-color: white;
  color: black;
}

.margin-top {
  margin-top: -40px;
}

.back {
  font-family: "SFProDisplay-Semibold";
}

.field {
  position: relative;
  display: inline-block;
}

/* .field__input {
  padding-right: 330px;
} */
.field__helper {
  position: absolute;
  right: 5px;
  top: 20px;
  letter-spacing: var(--unnamed-character-spacing-1-4);
  color: var(--progress-bar-filler);
  text-align: center;
  letter-spacing: 1.4px;
  color: #00c5e3;
  opacity: 1;
  cursor: pointer;
}

.already-account {
  color: var(--unnamed-color-6f7878);
  text-align: center;
  letter-spacing: 0.64px;
  color: #6f7878;
  background-color: #d0dada;
  opacity: 0.6;
}

.email-password-text {
  color: var(--progress-bar-filler);
  text-align: center;
  letter-spacing: 0.64px;
  color: white;
  opacity: 1;
}

.heading {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) var(--unnamed-font-size-28) / var(--unnamed-line-spacing-32) var(--unnamed-font-family-sf-pro-display);
  letter-spacing: var(--unnamed-character-spacing--0-16);
  color: var(--unnamed-color-000000);
  text-align: left;
  font: normal normal bold 28px/32px SF Pro Display;
  letter-spacing: -0.16px;
  color: #000000;
  font-weight: bold;
  opacity: 1;
}

.update-text {
  letter-spacing: var(--unnamed-character-spacing-0-56);
  color: var(--unnamed-color-6f7878);
  text-align: left;
  letter-spacing: 0.56px;
  color: #6f7878;
  opacity: 1;
}
label {
    text-align: left;
    color: #6F7878;
    font-size: 12px;
    letter-spacing: 0.4px;
    line-height: 22px;
    display: block;
}
input#password2, input#password1 {
    width: 52vw;
    display: block;
    float: left;

}
@media only screen and (min-width: 1010px) {
  input#password2, input#password1 {
    width:25vw;
  }
}
button.show-password {
  float: right;
  margin-right: 1rem;
  position: relative;
    bottom: 5px;
}
.password-box {
  height: 58px;
}
input {
  color: #424747;
  font-size:17px;
  line-height: 22px;
  text-align: left;
  letter-spacing: 0.56px;
}
input[type=password] {
  font-weight: 100;
  font: menu;
  letter-spacing: 4px;
  font-family: 'SF Pro Display Regular'!important;
  padding-top: 6px;
}
input[type=password]::placeholder {
  color: #D0DADA;
    font-size: 17px;
    line-height: 22px;
    text-align: left;
    letter-spacing: 0.56px;
}
</style>